module.exports = __webpack_public_path__ + "static/MintAgency-f31399f4d6134f4e851d158db128bdeb.jpg";